import pushToDataLayer, { PushEventType } from '@spa/lib/tracking/pushToDataLayer';

export const pushMultipleToDataLayer = (events: ReadonlyArray<PushEventType>): void => {
  events.forEach((event: PushEventType) => pushToDataLayer(event));
};

export default pushMultipleToDataLayer;
